import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { Action } from 'redux';

// API
export interface MailDetailFetchAction extends Action {
    readonly id: number;
}

export const MAIL_DETAIL_FETCH_REQUEST = 'MAIL_DETAIL_FETCH_REQUEST';

export interface MailDetailFetchRequestAction extends MailDetailFetchAction, APIRequestAction {
    readonly type: typeof MAIL_DETAIL_FETCH_REQUEST;
}

export const MAIL_DETAIL_FETCH_SUCCESS = 'MAIL_DETAIL_FETCH_SUCCESS';

export interface MailDetailFetchSuccessAction extends MailDetailFetchAction, APISuccessAction {
    readonly type: typeof MAIL_DETAIL_FETCH_SUCCESS;
}

export const MAIL_DETAIL_FETCH_FAILURE = 'MAIL_DETAIL_FETCH_FAILURE';

export interface MailDetailFetchFailureAction extends MailDetailFetchAction, APIFailureAction {
    readonly type: typeof MAIL_DETAIL_FETCH_FAILURE;
}

export const mailDetailFetch = {
    request: (id: number): MailDetailFetchRequestAction => ({
        type: MAIL_DETAIL_FETCH_REQUEST, id,
    }),
    success: (id: number, response: any): MailDetailFetchSuccessAction => ({
        type: MAIL_DETAIL_FETCH_SUCCESS, id, response,
    }),
    failure: (id: number, error: any): MailDetailFetchFailureAction => ({
        type: MAIL_DETAIL_FETCH_FAILURE, id, error,
    }),
};

// Triggers
// MailDetail load
export const MAIL_DETAIL_LOAD = 'MAIL_DETAIL_LOAD';

export interface MailDetailLoadAction extends MailDetailFetchAction {
    readonly type: typeof MAIL_DETAIL_LOAD;
}

export const mailDetailLoad = (id: number): MailDetailLoadAction => ({
    type: MAIL_DETAIL_LOAD, id,
});

export const MAIL_DETAIL_READ = 'MAIL_DETAIL_READ';

export interface MailDetailReadAction extends Action {
    readonly type: typeof MAIL_DETAIL_READ;
    readonly id: number;
}

export const mailDetailRead = (id: number): MailDetailReadAction => ({
    type: MAIL_DETAIL_READ,
    id,
});
